export enum AnalyticsEventSource {
  CASSI_SUPPORT_ISSUE_SCREEN = 'cassiSupportIssueScreen',
  CASSI_ADMIN_SCREEN = 'cassiAdminScreen',
  CONTACT_SCREEN = 'contactScreen',
  DOMAIN_SCREEN = 'domainScreen',
  EMAIL_SCREEN = 'emailScreen',
  ENTITLEMENT_SCREEN = 'entitlementScreen',
  ERROR_SCREEN = 'errorScreen',
  INVOICE_SCREEN = 'invoiceScreen',
  NOT_FOUND_SCREEN = 'notFoundScreen',
  ORGANIZATION_SCREEN = 'organizationScreen',
  PARTNER_SCREEN = 'partnerScreen',
  PARTNER_HOME_SCREEN = 'partnerHomeScreen',
  PARTNER_DETAILS_SCREEN = 'partnerDetailsScreen',
  PARTNER_ACCOUNT_BALANCE_SCREEN = 'partnerAccountBalanceScreen',
  PARTNER_QUOTES_SCREEN = 'partnerQuotesScreen',
  PARTNER_INVOICES_SCREEN = 'partnerInvoicesScreen',
  PARTNER_INVOICE_DETAILS_SCREEN = 'partnerInvoiceDetailsScreen',
  PARTNER_CONFIRM_PAYMENT_SCREEN = 'partnerConfirmPaymentScreen',
  PARTNER_REFUNDS_SCREEN = 'partnerRefundsScreen',
  PARTNER_SUBSCRIPTIONS_SCREEN = 'partnerSubscriptionsScreen',
  PARTNER_INTERNAL_LICENSES_SCREEN = 'partnerInternalLicensesScreen',
  PARTNER_ORGANISATION_SCREEN = 'partnerOrganisationScreen',
  PARTNER_CATALOG_SCREEN = 'partnerCatalogScreen',
  PARTNER_ENTITLEMENT_SCREEN = 'partnerEntitlementScreen',
  PARTNER_DUMMY_SCREEN = 'partnerDummyScreen',
  PARTNER_SEARCH_SCREEN = 'partnerSearchScreen',
  PARTNER_CUSTOMER_ADDRESS_SCREEN = 'partnerCustomerAddressScreen',
  PARTNER_BILLING_PROFILE_DETAILS_SCREEN = 'partnerBillingProfileDetailsScreen',
  PARTNER_CUSTOMER_ADDRESS_DETAIL_SCREEN_BY_ID = 'partnerCustomerAddressDetailScreenById',
  PARTNER_CUSTOMER_ADDRESS_DETAIL_SCREEN_BY_COMPANY = 'partnerCustomerAddressDetailScreenByCompany',
  PARTNER_CLOUD_SITE_SCREEN = 'partnerCloudSiteScreen',
  PARTNER_EMAIL_DETAIL_SCREEN = 'partnerEmailDetailScreen',
  PARTNER_ORDER_DETAIL_SCREEN_BY_ID = 'orderDetailsPageById',
  CART_SCREEN = 'cartScreen',
  ORDER_SCREEN = 'orderScreen',
  PARTNER_IMPORT_SUBSCRIPTION_SCREEN = 'partnerImportSubscription',
  PARTNER_ADD_PAYMENT_METHOD_SCREEN = 'partnerAddPaymentMethodScreen',
  PARTNER_QUOTES_DETAILS_SCREEN = 'partnerQuoteDetailsScreen',
  QUOTE_SCREEN = 'quoteScreen',
  PARTNER_ONBOARDING_SCREEN = 'partnerOnboardingScreen',
  PARTNER_ONBOARDING_MANAGE_TOKEN_SCREEN = 'partnerOnboardingManageTokenScreen',
  REFUND_SCREEN = 'refundScreen',
  SEARCH_SCREEN = 'searchScreen',
  SUPPORT_TICKET_SCREEN = 'supportTicketScreen',
  UNAUTHORIZED_SCREEN = 'unauthorizedScreen',
  TRANSACTION_ACCOUNT_SCREEN = 'transactionAccountScreen',
  TRANSACTION_ACCOUNT_BALANCE = 'transactionAccountBalanceScreen',
  INVOICE_GROUP_SCREEN = 'invoiceGroupScreen',
  PRODUCTS_SCREEN = 'productsScreen',
  APPROVAL_DESK_SCREEN = 'approvalDeskScreen',
  PORTAL_APP = 'portalAppScreen',
  CREDIT_DETAILS = 'creditDetailsScreen',
  CREATE_QUOTE = 'createQuote',
  NAVIGATION_BAR = 'navigationBar',
  PARTNER_COMING_SOON_SCREEN = 'partnerComingSoonScreen',
  PARTNER_CREDIT_DETAILS_SCREEN = 'partnerCreditDetailsScreen',
  PARTNER_NOTIFICATION_PREFERENCE_SCREEN = 'partnerNotificationPreferenceScreen',
  PARTNER_QUOTE_ORDER_SUMMARY_SCREEN = 'partnerQuoteOrderSummaryScreen',
  PARTNER_CATALOG_DETAILS_SCREEN = 'catalogDetailsScreen',
  UOF_SELECT_CUSTOMER_SCREEN = 'uofSelectCustomerScreen',
  UOF_SELECT_BILLING_PROFILE_SCREEN = 'uofSelectBillingProfileScreen',
  PARTNER_DEAL_REGISTRATIONS_SCREEN = 'partnerDealRegistrationsScreen',
}

export enum AnalyticsUiAction {
  CLICKED = 'clicked',
  SEARCHED = 'searched',
  CHANGED = 'changed',
  EXIT = 'exit',
}

export enum AnalyticsUiSubject {
  BUTTON = 'button',
  LINK = 'link',
  NAV_ITEM = 'navItem',
  TABLE_ROW = 'tableRow',
  FORM = 'form',
  FILTER = 'filter',
  TAB = 'tab',
  DROPDOWN = 'dropdown',
  USER = 'user',
  SIDEBAR_BUTTON = 'sidebarButton',
}

export enum AnalyticsTag {
  REDIRECT = 'redirect',
  SIDEBAR = 'sidebar',
  CLOUD_SITE = 'cloudSite',
  NAVBAR = 'navbar',
}

export enum ScreenType {
  V2 = 'v2',
  V1 = 'v1',
}

export enum EntitlementPageType {
  ATLASSIAN_ACCESS = 'atlassianAccess',
  BITBUCKET = 'bitbucket',
  CLOUD_SITE = 'cloudSite',
  GENERIC = 'generic',
  LICENSE = 'license',
  SERVICE = 'service',
  STATUSPAGE = 'statuspage',
}

export enum ApprovalDeskPageType {
  TASK_MANAGER = 'taskManager',
  PROCESS_MANAGER = 'processManager',
}

export enum AnalyticsTrackAction {
  CREATED = 'created',
  UPDATED = 'updated',
  SEARCHED = 'searched',
  DELETED = 'deleted',
  SENT = 'sent',
  CANCEL = 'cancel',
  REACTIVATE = 'reactivated',
  REFUND = 'refunded',
  CHANGE_SCHEDULED = 'changeScheduled',
  ADD_SCHEDULED = 'addScheduled',
  REMOVE_SCHEDULED = 'removeScheduled',
  APPLIED = 'applied',
  REMOVED = 'removed',
  REBILL = 'rebilled',
  ADDED = 'added',
  DEACTIVATE = 'deactivated',
  REQUEST = 'requested',
  CALCULATED = 'calculated',
  DOWNLOADED = 'downloaded',
  PLACED = 'placed',
  CHANGED = 'changed',
  FAILED = 'failed',
  EDITED = 'edited',
  SUCCESSFUL = 'successful',
  DEACTIVATION_SUCCESS = 'deactivationSuccess',
  DEACTIVATION_FAILED = 'deactivationFailed',
  DEACTIVATION_NOT_ALLOWED = 'deactivationNotAllowed',
}

export enum AnalyticsTrackSubject {
  CHANGE_PLAN = 'changePlan',
  CHANGE_BILL_DATE = 'changeBillDate',
  PRICING = 'pricing',
  CHANGE_PRICING_PLAN = 'changePricingPlan',
  CLOUD_SITE_REACTIVATE = 'cloudSiteReactivate',
  CLOUD_SITE_DEACTIVATE = 'cloudSiteDeactivate',
  CLOUD_SITE_DELETE = 'cloudSiteDelete',
  CLOUD_SITE_PRODUCT_DELETE = 'cloudSiteDeleteProducts',
  CLOUD_SITE_EXTEND_EVAL = 'cloudSiteExtendEval',
  CLOUD_SITE_EXTENDED_TRIAL = 'cloudSiteExtendedTrial',
  CLOUD_RENAME = 'cloudSiteRename',
  REFUND = 'refund',
  SLA_CREDIT = 'slaCredit',
  LICENSE_REPORT = 'licenseReport',
  USER_REPORT = 'accessUserReport',
  BITBUCKET_CHANGE_PLAN = 'bitbucketChangePlan',
  CONVERT_TO_PAID = 'cloudSiteConvertToPaid',
  SEARCH_ALL = 'searchAll',
  RENEWAL_ACTION = 'renewalAction',
  EVE_WHITELIST_USER = 'eveWhitelistUser',
  EVE_DEACTIVATE_USER = 'eveDeactivateUser',
  RESET_PASSWORD = 'resetPassword',
  VERIFY_USER = 'verifyUser',
  ATLASSIAN_ACCOUNT = 'atlassianAccount',
  DOMAIN = 'domain',
  SWITCH_TRIAL_TO_ANNUAL = 'switchTrialToAnnual',
  UPDATE_ENTITLEMENT_PLAN = 'updateEntitlementPlan',
  UPDATE_TRANSACTION_ACCOUNT = 'updateTransactionAccount',
  SEARCH_NAVIGATION = 'searchNavigation',
  CANCEL_SUBSCRIPTION = 'cancelSubscription',
  REACTIVATE_SUBSCRIPTION = 'reactivateSubscription',
  CREATE_TRANSACTION_ACCOUINT = 'createTransactionAccount',
  APP_SWITCHER = 'appSwitcher',
  NAVIGATION_BAR_SETTINGS = 'navigationSettings',
  NAVIGATION_BAR_SETTINGS_ACCESS_MANAGEMENT = 'navigationSettingsAccessManagement',
  NAVIGATION_BAR_SETTINGS_FEATURE_FLAGS = 'navigationSettingsFeatureFlags',
  NAVIGATION_BAR_SETTINGS_REPORTS = 'navigationSettingsReports',
  DISCOUNT = 'discount',
  SUBSCRIPTION = 'subscription',
  QUOTE = 'quote',
  TRANSACTION_ACCOUNT = 'transactionAccount',
  BILLING_ACCOUNT = 'billingAccount',
  BILLING_PROFILE = 'billingProfile',
  PRICING_ELIGIBILITY = 'pricingEligibility',
  PAYMENT_METHOD = 'paymentMethod',
  SOLD_TO_ADDRESS = 'soldToAddress',
  RESENT_INVOICE = 'resentInvoice',
  INVOICE_JSON = 'invoiceJSON',
  INVOICE_PDF = 'invoicePDF',
  BILL_ESTIMATE = 'billEstimate',
  REVIEW_ORDER = 'reviewOrder',
  EXPORT_PDF = 'exportPDF',
  EXPORT_JSON = 'exportJSON',
  ORDER_PDF = 'orderPDF',
  ORDER_JSON = 'orderJSON',
  ORDER = 'order',
  NAVIGATION_BAR_PARTNER_ONBOARDING = 'navigationSettingsPapiOnboarding',
  MANAGE_NOTIFICATION_PREFERENCE = 'notificationPreferenceSettings',
  QUOTE_ORDER = 'quoteOrder',
  QUOTE_JSON = 'quoteJSON',
  QUOTE_PDF = 'quotePDF',
  NEW_CUSTOMER = 'newCustomer,',
  CUSTOMER_SOLD_TO_ADDRESS = 'customerSoldToAddress',
  AUTO_FIX_DRAFT_QUOTE = 'autoFixDraftQuote',
  ADD_CREDIT_CARD = 'addCreditCard',
  ADD_CUSTOMER = 'addCustomer',
  SWITCH_BILLING_PROFILE = 'switchBillingProfile',
  OPTOUT_TRIAL = 'optoutTrial',
  SELF_HELP = 'selfHelp',
}

export enum PPCAnalyticsTrackSubject {
  PLACE_ORDER = 'placeOrder',
  APP_OR_PRODUCT_ORDER = 'appOrProductOrder',
  NEW_APP_OR_PRODUCT_ORDER = 'newAppOrProductOrder',
}

export enum PlanType {
  UPGRADE = 'UPGRADE',
  DOWNGRADE = 'DOWNGRADE',
}

export enum AnalyticsButtonLabels {
  DELETE_ATLASSIAN_ACCOUNT = 'deleteAtlassianAccount',
  OBFUSCATE_ATLASSIAN_ACCOUNT = 'ObfuscateAtlassianAccount',
  GET_PASSWORD_RESET_LINK = 'getPasswordResetLink',
  GET_EMAIL_VERIFICATION_LINK = 'getEmailVerificationLink',
  OPEN_IN_GSAC = 'openInGSAC',
  OPEN_IN_CASSI = 'openInCASSI',
  ADA = 'ada',
  SEARCH_CLOUD_SITE = 'searchCloudSite',
  SHOW_ALL_CLOUD_SITE = 'showAllCloudSite',
  GENERATE_LICENSE_REPORT_LINK = 'generateLicenseReportLink',
  VIEW_IN_BB_ADMIN = 'viewInBBAdmin',
  PARTNER_SERVICE_DESK = 'openPartnerServiceDesk',
  CANCEL_QUOTE = 'cancelQuote',
  CLONE_QUOTE = 'cloneQuote',
  PREVIEW_QUOTE = 'previewQuote',
  REVISE_QUOTE = 'reviseQuote',
  FINALIZE_QUOTE = 'finalizeQuote',
  ADD_QUOTE = 'addQuote',
  CALCULATE_BILL_ESTIMATE = 'calculateBillEstimate',
  PLACE_QUOTE_ORDER = 'placeQuoteOrder',
  AUTO_FIX_QUOTE = 'autoFixQuote',
  REQUEST_QUOTE_SUPPORT = 'requestQuoteSupport',
  DEACTIVATE_BILLING_PROFILE = 'deactivateBillingProfile',
}
